import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormArray } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { MessageModule } from 'primeng/message';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import type { ProcessedCharge } from '../../services/freeze-charge.service';
import { FreezeChargeService } from '../../services/freeze-charge.service';
import { inject } from '@angular/core';

@Component({
  selector: 'freeze-charge-breakdown',
  templateUrl: './freeze-charge-breakdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    InputNumberModule,
    MessageModule,
    ProgressSpinnerModule,
    TranslateModule,
    CurrencyformatPipe,
  ],
})
export class FreezeChargeBreakdownComponent {
  private chargeService = inject(FreezeChargeService);

  readonly charges = input<ProcessedCharge[]>([]);
  readonly isLoading = input<boolean>(false);
  readonly applyDiscount = input<boolean>(false);
  readonly discountApplied = input<boolean>(false);
  readonly inValidDiscount = input<boolean>(false);
  readonly singleStaffDiscount = input<number>(0);
  readonly isInclusive = input<boolean>(false);
  readonly chargeAmountsArray = input<UntypedFormArray>(new UntypedFormArray([]));
  readonly chargeDiscountsArray = input<UntypedFormArray>(new UntypedFormArray([]));

  readonly applyDiscountToggle = output<void>();
  readonly cancelDiscount = output<void>();
  readonly removeDiscount = output<void>();
  readonly chargeDiscountBlur = output<number>();
  readonly chargeAmountBlur = output<number>();

  getChargeNetCost(charge: ProcessedCharge): number {
    return this.chargeService.getChargeNetCost(
      charge as { taxable_cost_in_minor_currency: number; tax: Array<{ amt_in_minor_currency: number }> },
      this.isInclusive()
    );
  }

  getTotalChargeTaxAmount(): number {
    return this.chargeService.getTotalChargeTaxAmount(
      this.charges() as Array<{ tax: Array<{ amt_in_minor_currency: number }> | null }>
    );
  }

  getChargeTaxBreakdown(charge: ProcessedCharge): Array<{ type: string; amt_in_minor_currency: number; rate: number }> {
    return this.chargeService.getChargeTaxBreakdown(
      charge as { tax: Array<{ id: number; type: string; amt_in_minor_currency: number; rate: number }> | null }
    );
  }

  getTotalOneTimeCost(): number {
    return this.chargeService.getTotalOneTimeCost(this.charges());
  }

  getFormControl(index: number) {
    return this.chargeAmountsArray().at(index);
  }

  getDiscountControl(index: number) {
    return this.chargeDiscountsArray().at(index);
  }

  onApplyDiscountToggle(): void {
    this.applyDiscountToggle.emit();
  }

  onCancelDiscount(): void {
    this.cancelDiscount.emit();
  }

  onRemoveDiscount(): void {
    this.removeDiscount.emit();
  }

  onChargeDiscountBlur(index: number): void {
    this.chargeDiscountBlur.emit(index);
  }

  onChargeAmountBlur(index: number): void {
    this.chargeAmountBlur.emit(index);
  }
}
